<template>
  <div id="searchComponent" class="fixed-top col-12 col-sm-6 col-md-7 col-lg-7 offset-sm-3 offset-md-3 offset-lg-2 mt-2">
    <div class="col-md-12">
        <div class="row">
            <div class="col-12">
              <div class="row">
                  <div class="input-group col-md-12">
                    <input ref="inputSearch" class="form-control bg-light search py-2 border-right-0 border" type="search" value="" placeholder="Buscar productos" aria-label="Buscar" v-model="keyWord" @click="clearLocalStorageFiltro"  @keyup="loadCategorias" @keyup.enter.prevent="handleEnterKey">
                    <span class="input-group-append">
                      <a :href="url_destino" class="btn btn-light text-black border-left-0 border" @click="setFilter('Titulo: '+keyWord)">
                          <i class="fa fa-search"></i>
                      </a>
                    </span>
                  </div>
              </div>
                <div ref="div_resultados" id="results" class="d-none row py-2 shadow">
                    <div class="list-group col-12 px-0">
                        <li class="list-group-item disabled border-0 font-weight-bold">Coincidencias</li>
                        <a v-for="(categoria, index) in categorias['titulo']" v-bind:value="categoria.id" :key="index" :href="url_destino" class="list-group-item list-group-item-action d-flex justify-content-between align-items-center border-0 py-2" @click="setFilter(categoria.tipo_v+' '+categoria.valor)">{{categoria.valor}}</a>
                    </div>
                    <!-- div class="list-group col-md-6 col-lg-4 border-right border-left px-0 d-none d-md-block">
                      <li class="list-group-item disabled border-0 font-weight-bold pb-2">Marcas</li>
                        <a v-for="(categoria, index) in categorias['marca']" v-bind:value="categoria.id" :key="index" :href="url_destino" class="list-group-item list-group-item-action d-flex justify-content-between align-items-center border-0 py-2" @click="setFilter(categoria.tipo_v+' '+categoria.valor)">{{categoria.valor}}</a>
                    </div>
                    <div class="list-group col-lg-4 px-0 d-none d-lg-block">
                        <li class="list-group-item disabled border-0 font-weight-bold pb-2">Categorías</li>
                        <a v-for="(categoria, index) in categorias['categoria']" v-bind:value="categoria.id" :key="index" :href="url_destino" class="list-group-item list-group-item-action d-flex justify-content-between align-items-center border-0 py-2" @click="setFilter(categoria.tipo_v+' '+categoria.valor)">{{categoria.valor}}</a>
                    </div -->
                </div>
            </div>
        </div>
    </div>
  </div>  
</template>
<script>
import { valueToNode } from '@babel/types';

export default {
  props: ["posts", "total", "pCurrentPage"],
    data: function () {
        return {
            categorias: [],
            keyWord:'',
            posts_filter: [],
            total_filter: 0,
            currentPage_filter: 1,
            url_destino: '',
            saltar_watch: false
        };
    },
    mounted() {
      // Escuchar el evento 'submit' del formulario padre
      if (localStorage.filtro){
        let buscar = localStorage.filtro.split(': ');
        this.keyWord = buscar[1] != 1 && buscar[1] != 100 && buscar[0] != 'Usuario' && buscar[0] != 'Usuario_100' && buscar[0] != 'Relacionados' && buscar[0] != 'Relacionados_100' ? buscar[1] : '';
      }
      if (this.$route.path == '/inicio' || this.$route.path == '/'){
        this.clearLocalStorageFiltro();
        this.keyWord = '';
      }   
      window.scrollTo(0, 0);   
    },
    watch: {
      keyWord(nuevoValor) {
        if (nuevoValor == '' ){
          //if (!this.saltar_watch){
            this.loadCategorias();
          //}          
          this.$refs.div_resultados.classList.add('d-none');
        }
    }
  },
    methods: {
        loadCategorias() {
            axios.get("/api/categoria/categoryPosts", {
            params: {
              buscar: this.keyWord,
            },
          }
            
            ).then((response) => {
                this.categorias = response.data;
                if (this.categorias != '' && this.keyWord != ''){
                  this.$refs.div_resultados.classList.remove('d-none');
                }
            }).catch((error) => {
              this.$refs.div_resultados.innerHTML='';
            });
        },
        setFilter(filtro){
          localStorage.filtro = filtro;
          let buscar = filtro.split(': ');          
          
          this.keyWord = buscar[1];
          localStorage.filtro = filtro;
          const destino = `${this.$route.path}`;
          const keywords = ['/inicio', '/sale/post', '/compras', '/pujas', '/user/acount', '/Dashbord/user/'];
          const containsKeyword = keywords.some(keyword => destino.includes(keyword));

          let ruta = '';
          if (containsKeyword){
            ruta = '/inicio/list';
          }else{
            ruta = '/list';
          }
          //esconde el resultado y borra lo buscado
          this.$refs.div_resultados.classList.add('d-none');
          this.keyWord = '';

          //establece la url de destino
          this.url_destino = ruta;
        },
        clearLocalStorageFiltro(){
          localStorage.filtro = '';
        },
        handleEnterKey() {
          setTimeout(() => {
            //this.keyWord = '';
            this.saltar_watch = true;
            
            this.setFilter('Titulo: '+this.keyWord);
            window.location.href = this.url_destino;
          }, 200);
          this.$refs.div_resultados.classList.add('d-none');          
        },
    }
};
</script>
<style lang="css">
@media (max-width: 568px){
  #searchComponent {
    top: 38px !important; 
  }
}



@media (min-width: 1024px){
  #searchComponent {
    max-width: 50% !important; 
    margin-left: 25%;
    flex: 0 0 50%;
  }
}
</style>